import { createFileRoute } from "@tanstack/react-router"
import { CompanyImagesPage } from "@/features/companies/company-images-page"

export const Route = createFileRoute("/_authenticated/companies/$companyId/images")({
    component: CompanyImagesPage,
})
